<template>
    <li style="list-style: none">
    <div class="donate">
        <div
            v-if="data.is_slam"
            class="donate__icon"
            :style="{
                backgroundColor: panelDesign.bulletColor,
            }"
        >
            <div
                v-if="showSlamIndication"
                class="five-pointed-star"
                :style="{
                    '--star-color': panelDesign.slamColor,
                }"
            ></div>
            <div style="width: 16px;" v-else>&nbsp;</div>
        </div>
        <div
            v-if="!data.is_slam"
            class="donate__icon"
            :style="{
                backgroundColor: panelDesign.bulletColor,

            }"
        ><div style="width: 16px;">&nbsp;</div></div>
        <div>
            <div class="mb-1">
                <span
                    class="donate__title"
                    :style="{
                        color: panelDesign.textColor,
                    }"
                    >{{ data.username }}</span
                >
                <span class="ml-1 mr-1" :style="{
                        color: panelDesign.textColor,
                    }">donated</span>
                <span
                    class="donate__amount"
                    :style="{
                        color: panelDesign.amountColor,
                    }"
                    >${{ amountCurrency }}</span
                >
            </div>
            <div
                v-if="data.desc && showDedication"
                class="donate__desc"
                :style="{
                    color: panelDesign.textColor,
                }"
            >
                {{ data.desc }}
            </div>
        </div>
    </div>
    </li>
</template>

<script>
export default {
    name: 'DonateItem',
    props: {
        data: Object,
        showSlamIndication: Boolean,
        showDedication: Boolean,
        panelDesign: Object,
    },
    computed: {
        amountCurrency() {
            return new Intl.NumberFormat().format(this.data.donate);
        },
    },
};
</script>

<style lang="scss" scoped>
.donate {
    //word-break: break-word;
    margin-bottom: 8px;
    font-size: 18px;
    display: flex;
    gap: 8px;

    &__icon {
        margin-top: 6px;
        width: 16px;
        height: 16px;
        background-color: #41b8dc;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        img {
            width: 100%;
            max-width: 100%;
        }
    }
    &__title {
        word-break: break-all;
        font-weight: 700;
    }
    &__amount {
        font-weight: 700;
        color: #41b8dc;
    }
    &__desc {
        font-size: 14px;
    }
}
.five-pointed-star {
    --star-color: #f9ed32;
    margin: 1em auto;
    font-size: 8px;
    position: relative;
    display: block;
    width: 0px;
    height: 0px;
    border-right: 1em solid transparent;
    border-bottom: 0.7em solid var(--star-color);
    border-left: 1em solid transparent;
    transform: rotate(35deg);
}
.five-pointed-star:before {
    border-bottom: 0.8em solid var(--star-color);
    border-left: 0.3em solid transparent;
    border-right: 0.3em solid transparent;
    position: absolute;
    height: 0;
    width: 0;
    top: -0.45em;
    left: -0.65em;
    display: block;
    content: '';
    transform: rotate(-35deg);
}
.five-pointed-star:after {
    position: absolute;
    display: block;
    top: 0.03em;
    left: -1.05em;
    width: 0;
    height: 0;
    border-right: 1em solid transparent;
    border-bottom: 0.7em solid var(--star-color);
    border-left: 1em solid transparent;
    transform: rotate(-70deg);
    content: '';
}
</style>
